import {$} from './util/jq';

export default (event, {progress: {total}}) => {
  $('.progress').find('.bar').width(`${total}%`);
};



// WEBPACK FOOTER //
// ./src/main/js/updateProgress.js